import { useLearnerProfileTagsWidgetQuery } from '@/modules/learner/views/LearnerProfile/graphql/queries/generated/learnerProfileTagsWidget';
import { LearnerWidgetProps } from '@/modules/learner/views/LearnerProfile/types';

import CardLoader from '../LearnerGroupsWidget/CardLoader';
import LearnerTagsWidget from './LearnerTagsWidget';

const LearnerTagsWidgetContainer = (props: LearnerWidgetProps) => {
  const { learner, onAction } = props;

  const [{ fetching, data, stale }] = useLearnerProfileTagsWidgetQuery({
    variables: { learnerId: learner.id },
  });

  if ((fetching || stale) && !data?.user?.tags) {
    return <CardLoader />;
  }

  return (
    <LearnerTagsWidget learnerId={learner.id} tags={data?.user?.tags ?? []} onAction={onAction} />
  );
};

export default LearnerTagsWidgetContainer;
